export default __webpack_public_path__ + "static/media/dirtstonefloor.c05d8243.png";